import cx from 'classnames';
import { format } from 'date-fns';
import React from 'react';
import { getMonthInfo, getWeekDay, isClosedMonth } from '../helpers';
import styles from './monthCalendar.module.scss';
import Week from './Week';
const MonthCalendar = ({ hidden = false, month, year, onSelectDate, onHoverDate, fromDate, toDate, hoverDate, isAnimating = true, startWeekDay, minDate, maxDate, monthFormat = 'MMMM yyyy', weekDayFormat = 'dd', highlightToday, singleCalendar = true, disabledDays, disabledDates = [], endSeasonDisabledDates = [], leadingPrices, availableDates, seasons, isLeadingPricesEnabled, isInventoryDrivenCalendarEnabled, showRelativePricing = false, }) => {
    function generateWeek() {
        const { totalWeek } = getMonthInfo(year, month, startWeekDay);
        return totalWeek.map((week, index) => (<Week key={index} week={week} month={month} year={year} isFirst={index === 0} onSelectDate={onSelectDate} onHoverDate={onHoverDate} fromDate={fromDate} toDate={toDate} hoverDate={hoverDate} minDate={minDate} maxDate={maxDate} highlightToday={highlightToday} disabledDays={disabledDays} disabledDates={disabledDates} endSeasonDisabledDates={endSeasonDisabledDates} leadingPrices={leadingPrices} availableDates={availableDates} isLeadingPricesEnabled={isLeadingPricesEnabled} isInventoryDrivenCalendarEnabled={isInventoryDrivenCalendarEnabled} showRelativePricing={showRelativePricing}/>));
    }
    function generateWeekDay() {
        const arrWeekDay = getWeekDay(startWeekDay, weekDayFormat);
        return arrWeekDay.map((day, index) => (<div className={styles.weekday} key={index}>
        {day}
      </div>));
    }
    return (<div className={cx(styles.monthCalendar, isAnimating && styles.isAnimating, hidden && styles.hidden, singleCalendar && styles.single)} data-month-index={month + 1}>
      <div className={styles.monthName}>{format(new Date(year, month, 1), monthFormat)}</div>
      <div className={styles.weekdays}>{generateWeekDay()}</div>
      <div className={styles.weekContainer} style={{ position: 'relative' }}>
        {generateWeek()}
        {isClosedMonth(year, month, seasons) && (<div className={styles.closedMonth}>Park closed for Winter</div>)}
      </div>
    </div>);
};
export default MonthCalendar;
